// src/value/AppModel.js

import { makeVar } from "@apollo/client";
import UserSessionInfo from "./UserSessionInfo";
import ValueMisc from "./ValueMisc";

export const NoUser = new UserSessionInfo(true);
const NoSessionCheckd = new UserSessionInfo(false); // {...NoUser, sessionChecked: false};
//export const custListRepo = makeVar([]); // for admin only.
export const appModeRepo = makeVar({isTsrPrinter: false, url: null}); // TSR 프린터 모드인지, URL에 planId.
export const currentPlanStatWithRentListRepo = makeVar({when:0, records:[]}); // currentPlanStatWithRent, VIEW (Home View 현황정보)
export const currentMenuRepo = makeVar({}); // {menuId, menuName, menuOrder}
export const menuRequestRepo = makeVar(null); // App 어디서든 AppMain으로 메뉴 요청을 보낼 수 있도록.
export const userInfoRepo = makeVar(NoSessionCheckd);
// 로그인하면 authTableTreeRepo 가져옴.
export const authTableTreeRepo = makeVar({when:0, tree: {}}); // authTable {jobName:{allow: [authClassId1, authClassId2, .....]}}
export const codeTreeRepo = makeVar([]); // 로그인하면 한세트 가져옴.
export const codeNameRepo = makeVar({});
export const dcInfoListRepo = makeVar({when:0, records:[]}); // dcInfo.
export const waveListRepo = makeVar([]); // 배차용 wave 코드 목록. 자주 쓰이므로 미리 만들어 놓기. ('선택'포함)
export const mapRequestRepo = makeVar({data: null}); // 새로운 요청을 하려면 data를 넣어 주면 됨.
export const alertQueueRepo = makeVar([]); // {title:'title', message:[], isError: true}

// menu item: {menuId, menuName, menuOrder}
export const mobileMenuAuthListRepo = makeVar({when:0, records:[]}); // 모바일용 메뉴별 권한 할당

// DC 배차현황.
export const transPlanStateForDcParamRepo = makeVar({planDate: ValueMisc.getYMD()});
export const transPlanAndActorListRepo = makeVar({when:0, records:[], param:{}, filter:{}}); // transPlanAndActor, 배차현황목록
export const transPlanTsrItemRepo = makeVar({}); // TRANS_PLAN_TSR item.
export const bulkCompanyProductsListRepo = makeVar({when:0, records:[], param:{}}); // bulkCompanyProducts, Bulk Company Products
export const arriveInfoListToSelectStoreRepo = makeVar({when:0, records:[]}); // arriveInfo
export const comInfoListRepo = makeVar({when:0, records:[]}); // comInfo
export const transPlanLaunchListRepo = makeVar({when:0, records:[]}); // transPlanTsr (launcher list)
export const transPlanLaunchListParamRepo = makeVar({dcCd:null, storeId:null, planDate:ValueMisc.getYMD()}); // for transPlanLaunchListRepo
export const vehInfoListOfDcRepo = makeVar({when:0, records:{}}); // vehInfoListOfDc (rent 무관)
export const vehTypeGroupOrderListByDcRepo = makeVar({when:0, records:[]}); // vehTypeGroupOrder - Select option DC별 차종 목록.
export const transPlanTsrListRepo = makeVar({when:0, records:[]}); // transPlanTsr, VIEW
export const arrivalToStoreListRepo = makeVar({when:0, records:[], param:{dateFrom: ValueMisc.getYMD()} }); // arrivalToStore, 점포관리.
export const arrivalToStoreListParamRepo = makeVar({dateFrom: ValueMisc.getYMD()});
export const transPlanListRepo = makeVar({when:0, records:[]}); // transPlan, 운송요청 배차내역 테이블(차량관제리스트)
export const transPlanListParamRepo = makeVar({planDate: null});
export const rtdTermPosListRepo = makeVar({when:0, records:[]}); // rtdTermPos, 차량별 최종 위치
export const transPlanResultListForRentRepo = makeVar({when:0, records:[]}); // transPlanResult, (용차)
// Clear data
export function clearReposForNewSession() {
    currentPlanStatWithRentListRepo({when:0, records:[]});
    // clear all data which has 'when' property.
	// ... Add this line
    transPlanStateForDcParamRepo({planDate: ValueMisc.getYMD()});
    transPlanAndActorListRepo({when:0, records:[], param:{}, filter:{}}); // 배차현황목록
    bulkCompanyProductsListRepo({when:0, records:[], param:{}}); // Bulk Company Products
    arriveInfoListToSelectStoreRepo({when:0, records:[]});
    comInfoListRepo({when:0, records:[]});
    transPlanLaunchListRepo({when:0, records:[]}); // transPlanTsr (launcher list)
    transPlanLaunchListParamRepo({dcCd:null, storeId:null, planDate:ValueMisc.getYMD()}); // for transPlanLaunchListRepo
    vehInfoListOfDcRepo({when:0, records:{}}); // records:{comId: [vehInfo]}
    vehTypeGroupOrderListByDcRepo({when:0, records:[]});
    transPlanTsrListRepo({when:0, records:[], param:{}}); // VIEW
    arrivalToStoreListRepo({when:0, records:[], param:{dateFrom: ValueMisc.getYMD()}}); // arrivalToStore, 점포관리.
    arrivalToStoreListParamRepo({dateFrom: ValueMisc.getYMD()});
    transPlanListRepo({when:0, records:[]}); // 운송요청 배차내역 테이블. 차량관제리스트.
    transPlanListParamRepo({planDate: null});
    rtdTermPosListRepo({when:0, records:[]}); // 차량별 최종 위치
    transPlanResultListForRentRepo({when:0, records:[]}); // transPlanResult, (용차)
}
